import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { AddMessage } from './add-message.action';
import { AddSingleMessage } from './add-single-message-action';
import { ClearMessages } from './clear-messages.action';
import { MessageCenterStateModel } from './message-center.model';
import { RemoveMessage } from './remove-message.action';
import { RemoveSingleMessage } from './remove-single-message-action';

@State<MessageCenterStateModel>({
  name: 'messageCenter',
  defaults: [],
})
@Injectable()
export class MessageCenterState {
  constructor(private store: Store) {}

  @Action(AddSingleMessage)
  addSingleMessage(ctx: StateContext<MessageCenterStateModel>, params: AddSingleMessage) {
    return params.execute({ ctx, store: this.store });
  }

  @Action(RemoveSingleMessage)
  removeSingleMessage(ctx: StateContext<MessageCenterStateModel>, params: RemoveSingleMessage) {
    return params.execute({ ctx, store: this.store });
  }

  @Action(AddMessage)
  @Action(RemoveMessage)
  removeMessage(ctx: StateContext<MessageCenterStateModel>, params: AddMessage | RemoveMessage) {
    return params.execute({ ctx, store: this.store });
  }

  @Action(ClearMessages)
  clearMessages(ctx: StateContext<MessageCenterStateModel>) {
    ctx.setState([]);
  }
}
